interface Grouped {
  slug: string;
  section: string;
}

export const expandedOnArrival = (pages: Grouped[], sectionSlugs: string[], initialSlug?: string): Set<string> => {
  const rendered = sectionSlugs.filter((slug) => pages.some((page) => page.section === slug));
  const landing = pages.find((page) => page.slug === initialSlug) ?? pages[0];

  const opening = landing !== undefined && rendered.includes(landing.section) ? landing.section : rendered[0];

  return new Set(opening === undefined ? [] : [opening]);
};

export const toggleSection = (expanded: Set<string>, section: string): Set<string> => {
  const next = new Set(expanded);

  if (!next.delete(section)) {
    next.add(section);
  }

  return next;
};

export const withSectionExpanded = (expanded: Set<string>, section?: string): Set<string> =>
  section === undefined || section.length === 0 || expanded.has(section) ? expanded : new Set(expanded).add(section);

export const expandMatchingSections = (expanded: Set<string>, pages: (Grouped & { haystack: string })[], needle: string): Set<string> => {
  if (needle.length === 0) {
    return expanded;
  }

  return pages.reduce((into, page) => (page.haystack.includes(needle) ? withSectionExpanded(into, page.section) : into), expanded);
};
